import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'surveying:home',
});

export const surveyRouteRef = createRouteRef({
  id: 'surveying:singlesurvey',
  params: ['surveyType', 'entityUid']
});
